import { useState, useEffect } from "react";
import api from "../utils/api";

import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    OutlinedInput,
    FormHelperText,
    Button,
    Box,
    FormControl,
    FormLabel,
    CircularProgress
} from "@mui/material";

export default function ChangePasswordModal({ open, onClose, row = null, endpoint = "" }) {
    const [saving, setSaving] = useState(false);
    const [errors, setErrors] = useState({});
    const [form, setForm] = useState({
        password: "",
        password_confirmation: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async () => {
        try {
            setSaving(true);
            setErrors({});

            await api.post(`${endpoint}/${row.id}/change-password`, form);
            onClose(true);
        } catch (e) {
            if (e.errors) {
                setErrors(e.errors);
            } else if (e.response?.data?.errors) {
                setErrors(e.response.data.errors);
            } else {
                setErrors({ password: [e.response?.data?.message || 'Failed to change password'] });
            }
        } finally {
            setSaving(false);
        }
    };

    useEffect(() => {
        if (open) {
            setForm({
                password: "",
                password_confirmation: "",
            });
            setErrors({});
            setSaving(false);
        }
    }, [open, row]);

    return (
        <Dialog open={open} onClose={() => onClose()} maxWidth="sm" fullWidth>
            <DialogTitle>Change Password{row ? ` for ${row.first_name} ${row.last_name}` : ''}</DialogTitle>
            <DialogContent>
                <Box display="flex" flexDirection="column" gap={2} mt={1}>
                    <FormControl error={!!errors.password?.[0]}>
                        <FormLabel htmlFor="password">New Password</FormLabel>
                        <OutlinedInput
                            name="password"
                            type="password"
                            fullWidth
                            value={form.password}
                            onChange={handleChange}
                        />
                        {errors.password && (
                            <FormHelperText sx={{ m: 0.5 }} error={!!errors.password}>
                                {errors.password[0]}
                            </FormHelperText>
                        )}
                    </FormControl>

                    <FormControl error={!!errors.password_confirmation?.[0]}>
                        <FormLabel htmlFor="password_confirmation">Confirm Password</FormLabel>
                        <OutlinedInput
                            name="password_confirmation"
                            type="password"
                            fullWidth
                            value={form.password_confirmation}
                            onChange={handleChange}
                        />
                        {errors.password_confirmation && (
                            <FormHelperText sx={{ m: 0.5 }} error={!!errors.password_confirmation}>
                                {errors.password_confirmation[0]}
                            </FormHelperText>
                        )}
                    </FormControl>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => onClose()}>Cancel</Button>
                <Button
                    sx={{ color: '#fff' }}
                    variant="contained"
                    onClick={handleSubmit}
                    disabled={saving || !form.password || !form.password_confirmation}
                >
                    {saving ? <CircularProgress size={24} /> : "Change Password"}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
